import React, { ButtonHTMLAttributes } from "react";
import "./index.scss";

const ActionButton = ({
  precedence = "PRIMARY",
  size = "NORMAL",
  children,
  className,
  ...remainingProps
}: {
  precedence?: "PRIMARY" | "SECONDARY";
  size?: "NORMAL" | "LARGE";
  ref?: React.RefObject<HTMLButtonElement | null>;
} & ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <button
      className={`component action-button precedence-${precedence.toLowerCase()} size-${size.toLowerCase()} ${className}`}
      {...remainingProps}
    >
      {children}
    </button>
  );
};

export default ActionButton;
